import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '../../../shared/Typography/PageTitle';
import { GeneralTable } from '../../../shared/Table/GeneralTable';
import { Box, styled, Typography } from '@mui/material';
import PrimaryBtn from '../../../shared/Buttons/PrimaryButton';
import { useNavigate } from 'react-router-dom';
import useQuotations from '../../../../hooks/quotations/useQuotations';
import { QUOTATION_HEAD_CELLS } from '../../../../utils/constans/tableHeads/quotationTableHeadCells';
import {
    QuotationData,
    QuotationsHeadCellContent,
} from '../../../../models/Quotations';
import { INVOICE_HEAD_CELLS } from '../../../../utils/constans/tableHeads/invoicesTableHead';
import { QuotationsTableRow } from '../../../quotations/QuotationsTableRow';

const TitleWrapper = styled(Box)(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: '20px',
}));

export const Quotations = () => {
    const { t } = useTranslation('quotations', {
        keyPrefix: 'QUOTATIONS',
    });
    const navigate = useNavigate();
    //TODO: bekötni a rest-et swr-el
    const quotations = useQuotations();
    const fullList = quotations.getQuotations();
    const isLoading = false;

    const tableHeadSettings = {
        translateNs: 'quotations',
        translatePrefix: 'QUOTATIONS.TABLE_HEAD',
        selectable: true,
        headContent: QUOTATION_HEAD_CELLS,
    };

    const tableToolbarSettings = {
        translateNs: 'quotations',
        translatePrefix: 'QUOTATIONS.TABLE_TOOLBAR',
    };

    const addNew = () => {
        navigate('/quotation/0');
    };

    const filterTerm = (search) => {
        return fullList.filter((elem) => {
            return (
                elem.quoteID.includes(search) ||
                elem.billToCustomerName
                    .toLowerCase()
                    .includes(search.toLowerCase())
            );
        });
    };

    const forceRefresh = () => {};

    return (
        <>
            <TitleWrapper>
                <PageTitle>{t('TITLE')}</PageTitle>
                <PrimaryBtn onClick={addNew}>{t('ADD_NEW')}</PrimaryBtn>
            </TitleWrapper>
            <Box>
                <Typography paragraph>{t('DESCRIPTION')}</Typography>
            </Box>
            <GeneralTable<QuotationData, QuotationsHeadCellContent>
                fullList={fullList}
                rowComponent={QuotationsTableRow}
                filterTerm={filterTerm}
                defaultOrderBy={'orderDate'}
                selectHandleId={'quoteID'}
                tableHeadSettings={tableHeadSettings}
                tableToolbarSettings={tableToolbarSettings}
                forceRefresh={forceRefresh}
                isLoading={isLoading}
            />
        </>
    );
};
